// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  padding: 0 10px;
}

p, h6 {
  text-align: start;
}

h6 {
  font-weight: 500;
  text-transform: none;
}

p {
  font-size: 14px;
}

ion-footer.invalid {
  background: darkgrey;
  color: grey;
}

swiper-container {
  height: 100%;
}

.wrapper {
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
}

.item-p {
  display: flex;
  padding: 15px;
  gap: 12px;
  border-radius: 12px;
  margin: 12px 20px 0;
  border: 1px solid var(--accent-color);
}
.item-p .quantity-selector {
  margin-left: auto;
}

.footer {
  padding: 15px 20px;
  margin-top: auto;
  border-top: 1px solid var(--accent-color);
  border-radius: 24px;
}
.footer ion-button {
  width: 100%;
}

.person-count-input {
  width: calc(100% - 40px);
  margin: 0 20px 12px;
  caret-color: #fff;
  border: 1px solid var(--accent-color);
  border-radius: 12px;
  padding: 8px 14px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/order/order.page.scss"],"names":[],"mappings":"AACA;EACE,eAAA;AAAF;;AAEA;EACE,iBAAA;AACF;;AACA;EACE,gBAAA;EACA,oBAAA;AAEF;;AAAA;EACE,eAAA;AAGF;;AAAA;EACE,oBAAA;EACA,WAAA;AAGF;;AADA;EACE,YAAA;AAIF;;AADA;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAIF;;AAFA;EACE,aAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;AAKF;AAJE;EACE,iBAAA;AAMJ;;AAFA;EACE,kBAAA;EACA,gBAAA;EACA,yCAAA;EACA,mBAAA;AAKF;AAJE;EACE,WAAA;AAMJ;;AAFA;EACE,wBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,mBAAA;EACA,4BAAA;AAKF","sourcesContent":["\nion-content {\n  padding: 0 10px;\n}\np,h6 {\n  text-align: start;\n}\nh6 {\n  font-weight: 500;\n  text-transform: none;\n}\np {\n  font-size: 14px;\n}\n\nion-footer.invalid {\n  background: darkgrey;\n  color: grey;\n}\nswiper-container {\n  height: 100%;\n}\n\n.wrapper {\n  height: 100%;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n}\n.item-p {\n  display: flex;\n  padding: 15px;\n  gap: 12px;\n  border-radius: 12px;\n  margin:12px 20px 0 ;\n  border: 1px solid var(--accent-color);\n  .quantity-selector {\n    margin-left: auto;\n  }\n}\n\n.footer {\n  padding: 15px 20px;\n  margin-top: auto;\n  border-top: 1px solid var(--accent-color);\n  border-radius: 24px;\n  ion-button {\n    width: 100%;\n  }\n}\n\n.person-count-input {\n  width: calc(100% - 40px);\n  margin: 0 20px 12px;\n  caret-color: #fff;\n  border: 1px solid var(--accent-color);\n  border-radius: 12px;\n  padding: 8px 14px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
